"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _DiscountPill = _interopRequireDefault(require("../../DiscountPill"));
var _useRecommendationCosts = require("../../../../hooks/recommendation/useRecommendationCosts");
var _recommendationSelectors = require("../../../../store/recommendation/recommendationSelectors");
var _services = require("../../../../services");
var _widgetSelectors = require("../../../../store/widget/widgetSelectors");
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _useAppSelector = require("../../../../hooks/useAppSelector");
var _constants = require("../../../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BorderWrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
  gap: 40px;
  padding: 20px 24px 40px 24px;
`;
const PageWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const FlexContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: ${props => props.breakPoints.sm ? 'column' : 'row'};
`;
const FlexItem = _styledComponents.default.div`
  flex-basis: ${props => props.columns === 2 ? '50%' : '33%'};
  padding: ${props => {
  var _props$padding$top, _props$padding, _props$padding$right, _props$padding2, _props$padding$bottom, _props$padding3, _props$padding$left, _props$padding4;
  return `${(_props$padding$top = (_props$padding = props.padding) === null || _props$padding === void 0 ? void 0 : _props$padding.top) !== null && _props$padding$top !== void 0 ? _props$padding$top : 0}px ${(_props$padding$right = (_props$padding2 = props.padding) === null || _props$padding2 === void 0 ? void 0 : _props$padding2.right) !== null && _props$padding$right !== void 0 ? _props$padding$right : 0}px ${(_props$padding$bottom = (_props$padding3 = props.padding) === null || _props$padding3 === void 0 ? void 0 : _props$padding3.bottom) !== null && _props$padding$bottom !== void 0 ? _props$padding$bottom : 0}px ${(_props$padding$left = (_props$padding4 = props.padding) === null || _props$padding4 === void 0 ? void 0 : _props$padding4.left) !== null && _props$padding$left !== void 0 ? _props$padding$left : 0}px `;
}};
`;
const AlignContainer = (0, _styledComponents.default)(FlexItem)`
  text-align: ${props => props.breakPoints.sm ? 'left' : 'right'};
`;
const MainTextWrapper = _styledComponents.default.div`
  display: flex;
  align-items: ${props => props.breakPoints.sm ? 'flex-start' : 'flex-end'};
  justify-content: ${props => props.breakPoints.sm ? 'flex-start' : 'flex-end'};
`;
const TextAndPillWrapper = _styledComponents.default.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;

  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      flex-direction: row;
      align-items: center;
    `)}
`;
const DiscountWrapper = _styledComponents.default.div`
  max-width: max-content;
  margin-bottom: 8px;
  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      margin-left: 8px;
      margin-bottom: 0;
    `)}
`;
const MaacSummaryCatergoryHeading = _ref => {
  let {
    text,
    productType,
    previousCategory
  } = _ref;
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const shouldRender = previousCategory !== productType;
  return shouldRender && /*#__PURE__*/_react.default.createElement(FlexContainer, {
    breakPoints: breakPoints,
    "data-testid": "summary-category-heading"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    text: text
  }));
};
const MaacSummarySection = () => {
  const {
    handset,
    plan,
    additionalPlans,
    broadband,
    businessSolution,
    addon,
    connectivityPlan,
    totalUpfrontCost,
    totalTermCost,
    totalTermCostBeforeDiscount
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  const numberOfPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const {
    showAveragePlanPrice
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const products = [handset, plan && {
    ...plan,
    additional: additionalPlans
  }, broadband, businessSolution, addon, connectivityPlan].filter(product => !!product).sort((a, b) => _constants.PRODUCT_DISPLAY_ORDER.indexOf(a.productType) - _constants.PRODUCT_DISPLAY_ORDER.indexOf(b.productType));
  const columns = totalTermCost && totalUpfrontCost ? 3 : 2;
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const textSize = (0, _useConfig.default)('textSize', 1);
  return /*#__PURE__*/_react.default.createElement(BorderWrapper, {
    "data-testid": "summary-wrapper"
  }, /*#__PURE__*/_react.default.createElement(PageWrapper, null, /*#__PURE__*/_react.default.createElement(FlexContainer, {
    breakPoints: breakPoints,
    "data-testid": "summary-heading"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: breakPoints.sm ? 3 : 1,
    weight: 2,
    text: _services.locale.localeString('Recommendation.Summary')
  })), /*#__PURE__*/_react.default.createElement(FlexContainer, {
    breakPoints: breakPoints,
    "data-testid": "summary-heading-divider"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), !breakPoints.sm && /*#__PURE__*/_react.default.createElement(FlexContainer, {
    breakPoints: breakPoints,
    "data-testid": "summary-table-labels"
  }, /*#__PURE__*/_react.default.createElement(FlexItem, {
    columns: columns
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('Recommendation.Products'))), !!totalUpfrontCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
    breakPoints: breakPoints,
    columns: columns
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('RelationshipOffer.Upfront'))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
    breakPoints: breakPoints,
    columns: columns
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('RelationshipOffer.Monthly')))), breakPoints.mdAndAbove && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    dataAttributes: {
      'data-testid': 'summary-table-divider'
    }
  }), products.map((product, index) => {
    var _product$additional;
    const discount = Math.round(100 * (1 - ((product === null || product === void 0 ? void 0 : product.termCost) + (product === null || product === void 0 ? void 0 : (_product$additional = product.additional) === null || _product$additional === void 0 ? void 0 : _product$additional.totalCost)) / ((numberOfPlans + 1) * (product === null || product === void 0 ? void 0 : product.termCost))));
    const previousCategory = index > 0 ? products[index - 1].productType : '';
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(MaacSummaryCatergoryHeading, {
      productType: product.productType,
      previousCategory: previousCategory,
      text: _services.locale.localeString(`Recommendation.${product.productType}`)
    }), /*#__PURE__*/_react.default.createElement(FlexContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(FlexItem, {
      columns: columns
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: breakPoints.sm ? 3 : 0
      }
    }, breakPoints.sm && previousCategory !== product.productType && /*#__PURE__*/_react.default.createElement(FlexItem, {
      columns: columns,
      "data-testid": "summary-mobile-product-heading"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('Recommendation.Products'), " "))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, product.name))), !!totalUpfrontCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns,
      "data-testid": "summary-upfront-value"
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': 'summary-mobile-upfront-heading'
      }
    }, _services.locale.localeString('RelationshipOffer.Upfront'))), /*#__PURE__*/_react.default.createElement(MainTextWrapper, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      weight: breakPoints.sm ? 3 : 2,
      noMargin: true
    }, _services.locale.formatPrice(product.upfrontCost)))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns,
      "data-testid": "summary-monthly-value"
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': 'summary-mobile-monthly-heading'
      }
    }, _services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(MainTextWrapper, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      weight: breakPoints.sm ? 3 : 2,
      noMargin: true
    }, _services.locale.formatPrice(product.termCost)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      size: textSize,
      weight: breakPoints.sm ? 3 : 2
    }, "/", _services.locale.localeString('Recommendation.month'))), product.termCostBeforeDiscount && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1
    }, _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: product === null || product === void 0 ? void 0 : product.termDuration,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(product.termCostBeforeDiscount),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    })))), product.additional && /*#__PURE__*/_react.default.createElement(FlexContainer, {
      breakPoints: breakPoints,
      "data-testid": "summary-additional-product"
    }, /*#__PURE__*/_react.default.createElement(FlexItem, {
      columns: columns
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: breakPoints.sm ? 3 : 0,
        top: breakPoints.sm ? 5 : 0
      }
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(FlexItem, {
      columns: columns
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('Recommendation.Products'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: breakPoints.sm ? 2 : 0
      }
    }, /*#__PURE__*/_react.default.createElement(TextAndPillWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true
    }, `${numberOfPlans} x ${_services.locale.localeString(`Recommendation.Additional.${product.additional.productType}`)}`), /*#__PURE__*/_react.default.createElement(DiscountWrapper, null, /*#__PURE__*/_react.default.createElement(_DiscountPill.default, {
      text: _services.locale.localeString('Recommendation.DiscountText', {
        amount: discount
      })
    })))))), !!totalUpfrontCost && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, breakPoints.sm && /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('RelationshipOffer.Upfront')))), /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns
    })), !!totalTermCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(AlignContainer, {
      breakPoints: breakPoints,
      columns: columns
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(MainTextWrapper, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      weight: breakPoints.sm ? 3 : 2
    }, _services.locale.formatPrice(product.additional.totalCost)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      size: 1,
      weight: breakPoints.sm ? 3 : 2
    }, "/", _services.locale.localeString('Recommendation.month'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1
    }, _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: product.additional.termDuration,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(product.additional.totalCostBeforeDiscount),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    })))));
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(FlexContainer, {
    breakPoints: breakPoints,
    "data-testid": "summary-footer"
  }, /*#__PURE__*/_react.default.createElement(FlexItem, {
    columns: columns,
    padding: {
      bottom: 6
    },
    "data-testid": "summary-footer-title"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    noMargin: true,
    text: numberOfPlans === 0 ? _services.locale.localeString('Recommendation.Total') : _services.locale.localeString('Recommendation.TotalNumOfPlans', {
      amount: numberOfPlans + 1
    }),
    weight: 3
  })), !!totalUpfrontCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
    breakPoints: breakPoints,
    columns: columns,
    "data-testid": "summary-footer-upfront"
  }, /*#__PURE__*/_react.default.createElement(MainTextWrapper, {
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    noMargin: true,
    text: _services.locale.formatPrice(totalUpfrontCost),
    weight: 3
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    noMargin: true,
    text: `${_services.locale.localeString('Recommendation.upfront')}`
  }))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(AlignContainer, {
    breakPoints: breakPoints,
    columns: columns,
    "data-testid": "summary-footer-monthly"
  }, /*#__PURE__*/_react.default.createElement(MainTextWrapper, {
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    noMargin: true,
    text: _services.locale.formatPrice(totalTermCost),
    weight: 3
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    noMargin: true,
    text: `/${_services.locale.localeString('Recommendation.month')}`
  })), !!totalTermCostBeforeDiscount && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: breakPoints.sm ? 2 : 1
  }, _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
    amount: plan === null || plan === void 0 ? void 0 : plan.termDuration,
    unit: _services.locale.localeString('Recommendation.month'),
    price: _services.locale.formatPrice(totalTermCostBeforeDiscount),
    pluralUnit: _services.locale.localeString('Recommendation.Month')
  })), showAveragePlanPrice && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: breakPoints.sm ? 3 : 2,
    noMargin: true,
    text: `${_services.locale.formatPrice(totalTermCost / (numberOfPlans + 1))}/${_services.locale.localeString('Recommendation.plan')}`,
    weight: breakPoints.sm ? 2 : 3
  })))));
};
var _default = MaacSummarySection;
exports.default = _default;